import {PTGC_DROPDOWN_OPEN} from './../../constants';

const openPushToGoogleCalendarDropDown = () => ({
  type: PTGC_DROPDOWN_OPEN
});

export default openPushToGoogleCalendarDropDown;